export const SITE = {
    brand: "Midasis Flyaway",
    tagline: "Where Every Journey Becomes a Story",
    email: "contact@midasisflyaway.com",
    whatsappRaw: "919866616657",
    whatsappDisplay: "+91 98666 16657",
    address:
        "Flat No. 301-B, Park View Edifice, Nandagiri Co-Op Housing Society Ltd., Jubilee Main Road, Journalist Colony, Jubilee Hills, Hyderabad, Telangana 500033",
    addressShort: "Jubilee Hills, Hyderabad",
    social: {
        instagram: "https://www.instagram.com/flyaway_midasis",
        facebook: "https://facebook.com",
        whatsapp: "https://wa.me/919866616657",
    },
};

export const waLink = (message = "Hi Midasis Flyaway, I'd like to know more about your travel packages.") =>
    `https://wa.me/${SITE.whatsappRaw}?text=${encodeURIComponent(message)}`;

export const DESTINATIONS = [
    {
        id: "maldives",
        name: "Maldives",
        country: "Maldives",
        region: "Islands",
        price: "From ₹ 2,40,000",
        tag: "Beach Paradise",
        image: "https://images.unsplash.com/photo-1514282401047-d79a71a590e8?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
        description: "Pristine white beaches, turquoise lagoons, overwater bungalows and barefoot luxury on the world's most idyllic shores.",
    },
    {
        id: "bali",
        name: "Bali",
        country: "Indonesia",
        region: "Islands",
        price: "From ₹ 1,25,000",
        tag: "Coconut & Culture",
        image: "https://images.unsplash.com/photo-1537996194471-e657df975ab4?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
        description: "Swaying coconut palms, ancient rice terraces, jungle temples and honeymoon villas with private plunge pools.",
    },
    {
        id: "dubai",
        name: "Dubai",
        country: "UAE",
        region: "Middle East",
        price: "From ₹ 1,40,000",
        tag: "Burj Khalifa Heights",
        image: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
        description: "Iconic Burj Khalifa skylines, desert dune safaris, world-class dining and luxury suites above the Palm.",
    },
    {
        id: "paris",
        name: "Paris",
        country: "France",
        region: "Europe",
        price: "From ₹ 1,85,000",
        tag: "Eiffel Tower Romance",
        image: "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
        description: "Champagne evenings beneath the Eiffel Tower, candle-lit bistros and quiet gardens in Le Marais.",
    },
    {
        id: "singapore",
        name: "Singapore",
        country: "Singapore",
        region: "Asia",
        price: "From ₹ 1,60,000",
        tag: "Marina Bay Sands",
        image: "https://images.unsplash.com/photo-1525625293386-3f8f99389edd?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
        description: "The iconic Marina Bay Sands infinity pool, Gardens by the Bay, hawker feasts and a dazzling city that never sleeps.",
    },
    {
        id: "swiss",
        name: "Switzerland",
        country: "Switzerland",
        region: "Europe",
        price: "From ₹ 2,25,000",
        tag: "Ice Mountains",
        image: "https://images.unsplash.com/photo-1531366936337-7c912a4589a7?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
        description: "Glacier express rides, snow-capped Alpine peaks, chalets in Zermatt and frozen lakes mirroring crystal skies.",
    },
    {
        id: "africa",
        name: "Africa Safari",
        country: "Tanzania",
        region: "Adventure",
        price: "From ₹ 2,75,000",
        tag: "Tigers & Wildlife",
        image: "https://images.unsplash.com/photo-1516426122078-c23e76319801?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
        description: "Witness majestic big cats on sunrise game drives, luxury tented camps under the stars and the Great Migration.",
    },
    {
        id: "usa",
        name: "USA",
        country: "USA",
        region: "Americas",
        price: "From ₹ 2,30,000",
        tag: "Statue of Liberty",
        image: "https://images.unsplash.com/photo-1485738422979-f5c462d49f74?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
        description: "Lady Liberty at dawn, Manhattan skylines, Grand Canyon vistas, Route 66 road trips and America's greatest national parks.",
    },
    {
        id: "australia",
        name: "Australia",
        country: "Australia",
        region: "Adventure",
        price: "From ₹ 2,60,000",
        tag: "Kangaroo Country",
        image: "https://images.unsplash.com/photo-1523482580672-f109ba8cb9be?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
        description: "Spot kangaroos in the wild, sail Sydney Harbour, snorkel the Great Barrier Reef and explore the ancient Outback.",
    },
    {
        id: "new-zealand",
        name: "New Zealand",
        country: "New Zealand",
        region: "Adventure",
        price: "From ₹ 2,90,000",
        tag: "Fiordland National Park",
        image: "https://images.unsplash.com/photo-1507699622108-4be3abd695ad?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
        description: "Milford Sound fjords, Fiordland's emerald wilderness, bungee jumps in Queenstown and Hobbiton at golden hour.",
    },
    {
        id: "japan",
        name: "Japan",
        country: "Japan",
        region: "Asia",
        price: "From ₹ 2,05,000",
        tag: "Japan Street Life",
        image: "https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
        description: "Neon-lit Tokyo alleyways, cherry blossoms in Kyoto, bullet trains, ramen bars and ancient shrine walks.",
    },
    {
        id: "china",
        name: "China",
        country: "China",
        region: "Asia",
        price: "From ₹ 1,90,000",
        tag: "Great Wall of China",
        image: "https://images.unsplash.com/photo-1508804185872-d7badad00f7d?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
        description: "Walk the legendary Great Wall, explore the Forbidden City, cruise the Li River and discover ancient dynasties.",
    },
    {
        id: "russia",
        name: "Russia",
        country: "Russia",
        region: "Europe",
        price: "From ₹ 2,00,000",
        tag: "Moscow Red Square",
        image: "https://images.unsplash.com/photo-1513326738677-b964603b136d?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
        description: "St. Basil's Cathedral at dusk, Moscow's iconic Red Square, Trans-Siberian rail and the grandeur of the Hermitage.",
    },
    {
        id: "kenya",
        name: "Kenya",
        country: "Kenya",
        region: "Adventure",
        price: "From ₹ 2,50,000",
        tag: "Wild Life",
        image: "https://images.unsplash.com/photo-1547471080-7cc2caa01a7e?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
        description: "The Masai Mara wildebeest migration, balloon safaris at sunrise, Maasai village stays and Africa's wildest skies.",
    },
    {
        id: "malaysia",
        name: "Malaysia",
        country: "Malaysia",
        region: "Asia",
        price: "From ₹ 1,35,000",
        tag: "Petronas Twin Towers",
        image: "https://images.unsplash.com/photo-1596422846543-75c6fc197f07?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
        description: "The soaring Petronas Twin Towers, Batu Caves, Langkawi beaches, rainforest canopy walks and Kuala Lumpur street food.",
    },
];

export const PACKAGES = [
    {
        id: "pkg-maldives-7",
        name: "Maldives — Overwater Escape",
        nights: "6 Nights / 7 Days",
        price: "₹ 2,40,000",
        perPerson: "per person (twin)",
        image: DESTINATIONS[0].image,
        inclusions: ["Return Flights", "5★ Overwater Villa", "All Meals", "Speedboat Transfers", "Snorkel Gear"],
        highlights: ["Sunset dolphin cruise", "Private sandbank dinner", "Spa at the reef"],
    },
    {
        id: "pkg-paris-6",
        name: "Paris & French Riviera",
        nights: "5 Nights / 6 Days",
        price: "₹ 1,85,000",
        perPerson: "per person (twin)",
        image: DESTINATIONS[3].image,
        inclusions: ["Return Flights", "4★ Boutique Hotel", "Daily Breakfast", "Seine Dinner Cruise", "Schengen Visa"],
        highlights: ["Eiffel skip-the-line", "Louvre private guide", "Day trip to Nice"],
    },
    {
        id: "pkg-japan-8",
        name: "Japan — Tokyo & Kyoto",
        nights: "7 Nights / 8 Days",
        price: "₹ 2,15,000",
        perPerson: "per person (twin)",
        image: DESTINATIONS[10].image,
        inclusions: ["Return Flights", "Ryokan + 5★ City Hotel", "Breakfast", "JR Pass", "Tea Ceremony"],
        highlights: ["Cherry blossom walks", "Fushimi Inari at dawn", "Shinkansen to Tokyo"],
    },
    {
        id: "pkg-kenya-7",
        name: "Kenya — Big Five Safari",
        nights: "6 Nights / 7 Days",
        price: "₹ 2,75,000",
        perPerson: "per person (twin)",
        image: DESTINATIONS[13].image,
        inclusions: ["Return Flights", "Luxury Tented Camp", "All Meals & Drinks", "Game Drives", "Ranger Guide"],
        highlights: ["Masai Mara sundowners", "Balloon safari add-on", "Maasai village visit"],
    },
    {
        id: "pkg-swiss-6",
        name: "Switzerland Alpine Retreat",
        nights: "5 Nights / 6 Days",
        price: "₹ 2,25,000",
        perPerson: "per person (twin)",
        image: DESTINATIONS[5].image,
        inclusions: ["Return Flights", "Alpine Chalet", "Breakfast", "Glacier Express Pass", "Airport Transfers"],
        highlights: ["Zermatt Matterhorn views", "Lake Geneva cruise", "Jungfraujoch day trip"],
    },
    {
        id: "pkg-bali-6",
        name: "Bali — Ubud & Seminyak",
        nights: "5 Nights / 6 Days",
        price: "₹ 1,25,000",
        perPerson: "per person (twin)",
        image: DESTINATIONS[1].image,
        inclusions: ["Return Flights", "Private Pool Villa", "Daily Breakfast", "Spa Ritual", "Airport Transfers"],
        highlights: ["Rice terrace cycling", "Tanah Lot temple", "Beach club afternoon"],
    },
];

export const TESTIMONIALS = [
    {
        name: "Sarah Johnson",
        role: "Honeymoon — Maldives",
        rating: 5,
        text: "From the welcome lounge at the airport to the overwater villa, every moment felt curated. Midasis turned our honeymoon into a memory we re-tell at every dinner.",
        image: "https://images.unsplash.com/photo-1623594675959-02360202d4d6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdCUyMHNtaWxpbmd8ZW58MHx8fHwxNzc2MzQ4MjY0fDA&ixlib=rb-4.1.0&q=85",
    },
    {
        name: "Michael Thompson",
        role: "Family — Switzerland",
        rating: 5,
        text: "They planned a three-country itinerary for our family of six, including my parents. The private Alps guide was exceptional — thoughtful, warm and deeply local.",
        image: "https://images.pexels.com/photos/17582358/pexels-photo-17582358.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    },
    {
        name: "Emily Rodriguez",
        role: "Solo — Japan",
        rating: 5,
        text: "A solo traveler's dream. Everything ran on time, the ryokan choice was stunning, and the 24/7 concierge made me feel safe and seen.",
        image: "https://images.unsplash.com/photo-1750187655549-b5009f762677?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdCUyMHNtaWxpbmd8ZW58MHx8fHwxNzc2MzQ4MjY0fDA&ixlib=rb-4.1.0&q=85",
    },
];

export const REGIONS = ["All", "Europe", "Asia", "Islands", "Adventure", "Middle East", "Americas"];
